export const initSearchState = {
  keyword: "",
  keywordType: "0",
  limit: 10,
  pageNo: 1,
};
